import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';


export class HeroesCommerceBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeHero: parseInt(this.props.activeHero),
            carouselInterval: null,
            pointerPrevActive: true,
            pointerNextActive: true
        };
        this.slidesNum = 3;
        this.updateActiveHero = this.updateActiveHero.bind(this);
        this.stepThroughHeroes = this.stepThroughHeroes.bind(this);
    }

    updateActiveHero(hero) { this.setState({ activeHero: hero}); }

    stepThroughHeroes(direction) {
        let activeHero = this.state.activeHero,
            slidesNum = this.slidesNum;
        if (direction === 'back') {
            if (activeHero > 1){
                activeHero -= 1;
            } else {
                activeHero = slidesNum;
            }
        } else {
            if (activeHero < slidesNum){
                activeHero += 1;
            } else {
                activeHero = 1;
            }
        }
        this.updateActiveHero(activeHero);
    }

    componentDidMount() {
        this.carouselInterval = setInterval(()=> {
            this.stepThroughHeroes('forward');
        }, 6000);
    }

    componentWillUnmount() {
        clearInterval(this.carouselInterval);
    }

    render() {
        let sCatalogHeaderTxt  = (this.props.path === '/catalog' || this.props.path === '/search' ? 'The Catalog' : 'Click To Shop The Catalog');
        let sCatalogActive     = (this.props.path === '/catalog' || this.props.path === '/search' ? 'active' : '');
        let activeHero = this.state.activeHero;
        let heroText = '';
        let overRideHero = {};
        let activeHeroLink = this.props['hero_link_' + activeHero];

        let heroLi = new Array(3).map(function (image, index) {
            return (
                <li className={"slide" + (activeHero === (index + 1) ? ' active' : '')} key={index}>
                    <div className="innerWrapper">
                        <div className="block">
                            <h6 className={"header-link " + sCatalogActive}>
                                <a href={"/catalog"} onClick={(evt) => this.props.dispatch(navigate(evt))}>{sCatalogHeaderTxt}</a>
                            </h6>
                        </div>
                        <div className="block">
                            {heroText}
                        </div>
                    </div>
                </li>
            );
        }, this);

        if( activeHero === 1 && this.props.promos && this.props.promos[0] && this.props.promos[0].promo_hero )
            overRideHero = { background: "#ffffff  url('https://s3.amazonaws.com/bookspan-media/excelsior-heroes/promo/" + this.props.promos[0].promo_hero + "') no-repeat center center" }

        return (
            <div className={`half-col right ${sCatalogActive} ${(activeHero === 1 ? 'slide-1' : activeHero === 2 ? 'slide-2' : 'slide-3')}`}
                style={overRideHero} >
                <div className="CommerceHeroes carouselSlidesWrapper">
                    <a className="overlayLink" href={activeHeroLink ? activeHeroLink : '/catalog'} onClick={(evt) => this.props.dispatch(navigate(evt))} />
                    <ul className="carouselSlides">
                        {heroLi}
                    </ul>

                    <div
                        className={"pointer left" + ((true) ? '' : ' hide') }
                        onClick={this.stepThroughHeroes.bind(this,"backward")}
                    >
                        <svg version="1.1"x="0px" y="0px" width="18.25px" height="34px" viewBox="0 0 18.25 34" enableBackground="new 0 0 18.25 34">
                            <polygon fill="rgba(255,255,255,.5)" points="17.157,0.343 0.257,17.244 17.014,34 18.029,32.985 2.288,17.243 18.172,1.357 "/>
                        </svg>
                    </div>
                    <div
                        className={"pointer right" + ((true) ? '' : ' hide') }
                        onClick={this.stepThroughHeroes.bind(this, "forward")}
                    >
                        <svg version="1.1" x="0px" y="0px" width="18.25px" height="34px" viewBox="0 0 18.25 34" enableBackground="new 0 0 18.25 34">
                            <polygon fill="rgba(255,255,255,.5)" points="1.35,34.001 18.25,17.1 1.493,0.344 0.478,1.358 16.22,17.101 0.335,32.986 "/>
                        </svg>
                    </div>
                    <div className="carouselBullets">
                        <ul>
                            <li
                                className={(activeHero === 1 ? 'active' : '')}
                                onClick={this.updateActiveHero.bind(this, 1)}
                            />
                            <li
                                className={(activeHero === 2 ? 'active' : '')}
                                onClick={this.updateActiveHero.bind(this, 2)}
                            />
                            <li
                                className={(activeHero === 3 ? 'active' : '')}
                                onClick={this.updateActiveHero.bind(this, 3)}
                            />
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
};

function mapStateToProps(state){
    return {
        tla: state.store.tla,
        promos: state.promos,
        hero_link_1: state.store.hero_link_1,
        hero_link_2: state.store.hero_link_2,
        hero_link_3: state.store.hero_link_3
    };
}

export default connect(mapStateToProps)(HeroesCommerceBar);



// WEBPACK FOOTER //
// ./src/components/HeroesCommerceBar.jsx